import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "section content-container" }
const _hoisted_2 = {
  key: 1,
  class: "container is-fluid"
}
const _hoisted_3 = { class: "island" }
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-right" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = { class: "table is-fullwidth" }
const _hoisted_8 = ["onClick"]

import { workspacesApi } from '@/workspaces/workspaces';
import { UserViewModel } from '@/workspaces/models/userViewModel';
import moment from 'moment';
import InviteUser from '@/features/settings/components/InviteUser.vue';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import Toast from '@/shared/services/toast';
import { computed, ref, onBeforeMount, PropType } from 'vue';
import { useStore } from 'vuex';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersInWorkspace',
  props: {
  providedWorkspace: {
    type: Object as PropType<WorkspaceViewModel>,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const workspace = computed(() => props.providedWorkspace ?? store.getters.currentWorkspace);
const userTerm = computed(() => (props.providedWorkspace ? 'users' : 'teammates'));

const isLoading = ref(false);
const users = ref<UserViewModel[]>([]);
const userToRemove = ref<UserViewModel>();
const showInviteUserModal = ref(false);
const showRemoveUserModal = ref(false);

onBeforeMount(async () => await getAllUsersForWorkspace());

function getStatus(status: number): string {
  if (status === 0) {
    return 'Pending';
  } else if (status === 1) {
    return 'Active';
  }
  return '';
}

function getStatusClass(status: number): string {
  if (status === 0) {
    return 'is-warning';
  } else if (status === 1) {
    return 'is-success';
  }
  return 'is-danger';
}

function formatDate(value: string): string {
  return moment(String(value)).format('DD MMM YYYY');
}

function openRemoveUserModal(user: UserViewModel): void {
  userToRemove.value = user;
  showRemoveUserModal.value = true;
}

function closeRemoveUserModal(): void {
  showRemoveUserModal.value = false;
}

function removeUser(): void {
  if (!userToRemove.value) return;

  workspacesApi
    .revokeUser(userToRemove.value.id, workspace.value.id)
    .then(() => {
      Toast.showSuccess(`Successfully removed teammate ${userToRemove.value!.userId}`);
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => {
      getAllUsersForWorkspace();
      closeRemoveUserModal();
    });
}

function getConfirmationMessage(): string {
  return `Are you sure you want to remove ${userToRemove.value!.userId} from ${workspace.value.name}?
  <br/><br/>
  Note that this will only remove their access to this workspace.`;
}

function openInviteUserModal() {
  showInviteUserModal.value = true;
}

function closeInviteUsersModal(refreshRequired: boolean) {
  if (refreshRequired) {
    getAllUsersForWorkspace();
  }
  showInviteUserModal.value = false;
}

async function getAllUsersForWorkspace() {
  isLoading.value = true;
  showRemoveUserModal.value = false;
  showInviteUserModal.value = false;
  users.value = await workspacesApi.getAllUsersForWorkspace(workspace.value.id);
  isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "level-left" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _createVNode(_component_n_button, {
                    onClick: openInviteUserModal,
                    variant: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, "Invite new " + _toDisplayString(userTerm.value), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Name"),
                  _createElementVNode("th", null, "Email"),
                  _createElementVNode("th", null, "Created"),
                  _createElementVNode("th", null, "Status"),
                  _createElementVNode("th")
                ])
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: user.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(user.displayName), 1),
                  _createElementVNode("td", null, _toDisplayString(user.userId), 1),
                  _createElementVNode("td", null, _toDisplayString(formatDate(user.createdTimeUtc)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["tag", getStatusClass(user.status)])
                    }, _toDisplayString(getStatus(user.status)), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (openRemoveUserModal(user)),
                      class: "icon is-small"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "trash" })
                    ], 8, _hoisted_8)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showRemoveUserModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 2,
          confirmationTitle: "Remove teammate",
          confirmationMessage: getConfirmationMessage(),
          onConfirm: _cache[0] || (_cache[0] = ($event: any) => (removeUser())),
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (closeRemoveUserModal()))
        }, null, 8, ["confirmationMessage"]))
      : _createCommentVNode("", true),
    (showInviteUserModal.value)
      ? (_openBlock(), _createBlock(InviteUser, {
          key: 3,
          workspace: workspace.value,
          "user-term": userTerm.value,
          onClose: closeInviteUsersModal
        }, null, 8, ["workspace", "user-term"]))
      : _createCommentVNode("", true)
  ]))
}
}

})